/*
 * Brand Pill Filter
 * -----------------
 * Displays pill-style brand filter buttons on collection pages.
 *
 * TO EDIT BRANDS: Change the BRANDS array below.
 * TO EDIT WHICH COLLECTIONS SHOW PILLS: Change the TARGET_COLLECTIONS array.
 *
 * Filtering uses Shopify's native vendor filter (?filter.p.vendor=Brand).
 */

(function () {
  // =============================================
  // EDIT YOUR BRANDS HERE
  // =============================================
  var BRANDS = [
    'LOUIS VUITTON',
    'GUCCI',
    'CHANEL',
    'DIOR',
    'FENDI',
    'CELINE',
    'PRADA',
    'LOEWE'
  ];

  // Collection handles (URL slugs) where pills should appear
  var TARGET_COLLECTIONS = ['all', 'shop-all', 'new-arrivals'];

  // Label for the reset pill when a brand is active
  var RESET_LABEL = 'Shop All Designer Bags';

  // =============================================
  // DO NOT EDIT BELOW UNLESS YOU KNOW WHAT YOU'RE DOING
  // =============================================

  function getCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^\/\?#]+)/);
    return match ? match[1].toLowerCase() : null;
  }

  function getActiveVendor() {
    var params = new URLSearchParams(window.location.search);
    return params.get('filter.p.vendor');
  }

  function buildFilterURL(brand) {
    var params = new URLSearchParams(window.location.search);

    if (brand) {
      params.set('filter.p.vendor', brand);
    } else {
      params.delete('filter.p.vendor');
    }

    // Reset to page 1 when changing filter
    params.delete('page');

    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function createPill(label, href, isActive) {
    var li = document.createElement('li');
    li.className = 'brand-pills__item';

    var link = document.createElement('a');
    link.className = 'brand-pills__pill';
    if (isActive) {
      link.className += ' brand-pills__pill--active';
      link.setAttribute('aria-current', 'true');
    }
    link.href = href;
    link.textContent = label;

    li.appendChild(link);
    return li;
  }

  function init() {
    var handle = getCollectionHandle();
    if (!handle || TARGET_COLLECTIONS.indexOf(handle) === -1) return;

    var activeVendor = getActiveVendor();

    // Build container
    var container = document.createElement('div');
    container.className = 'brand-pills';
    container.setAttribute('role', 'navigation');
    container.setAttribute('aria-label', 'Filter by brand');

    var pageWidth = document.createElement('div');
    pageWidth.className = 'page-width';

    var scroll = document.createElement('div');
    scroll.className = 'brand-pills__scroll';

    var list = document.createElement('ul');
    list.className = 'brand-pills__list';

    // If a brand is active, show reset pill first
    if (activeVendor) {
      list.appendChild(
        createPill(RESET_LABEL, buildFilterURL(null), false)
      );
    }

    // Brand pills
    BRANDS.forEach(function (brand) {
      var isActive = activeVendor && activeVendor.toLowerCase() === brand.toLowerCase();
      list.appendChild(
        createPill(brand, buildFilterURL(brand), isActive)
      );
    });

    scroll.appendChild(list);
    pageWidth.appendChild(scroll);
    container.appendChild(pageWidth);

    // Find insertion point - insert before the facet filters / product grid area
    var target =
      document.querySelector('.facet-filters') ||
      document.querySelector('.facet-filters-sticky') ||
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('.product-grid-container');

    if (target) {
      if (target.classList.contains('facet-filters') || target.classList.contains('facet-filters-sticky')) {
        target.parentNode.insertBefore(container, target);
      } else {
        target.parentNode.insertBefore(container, target);
      }
    }

    // On mobile, scroll the active pill into view
    if (activeVendor) {
      var activePill = container.querySelector('.brand-pills__pill--active');
      if (activePill) {
        setTimeout(function () {
          activePill.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
